export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/admin": [4],
		"/application": [5],
		"/articles": [6],
		"/articles/[id]": [7],
		"/check": [8],
		"/companies": [9],
		"/companies/[id]": [10],
		"/customers": [11],
		"/delivery": [12],
		"/delivery/[id]": [13],
		"/devices": [14],
		"/devices/[id]": [15],
		"/import": [16],
		"/input-test": [17],
		"/(login)/login": [3],
		"/lookup": [18],
		"/migration": [19],
		"/offer": [20],
		"/offer/[id]": [21],
		"/persons": [22],
		"/persons/[id]": [23],
		"/production": [24],
		"/production/[id]": [25],
		"/reservation": [26],
		"/reservation/[id]": [27],
		"/scan": [28],
		"/tasks": [29],
		"/tasks/[id]": [30],
		"/vehicles": [31],
		"/vehicles/[id]": [32],
		"/vehicles/[id]/protocols/[protocolId]": [33]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';